export default __webpack_public_path__ + "static/egp1@2x-51ca489febb851c8e847a4037ee16e89.jpg";